<template>
    <div class="text-center my-5">
        <div class="spinner-grow text-grey" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        data(){
            return {

            }
        },
        methods: {
            
        }
    }
</script>